"use strict";

exports.__esModule = true;
exports["default"] = exports.ModalWrapper = exports.ModalOverlay = exports.ModalContentWrapper = exports.CloseIconWrapper = exports.CloseIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../glyphs/elements");

var _utils = require("../../utils");

var _excluded = ["theme", "showFullscreenMobile", "large"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** The React component to display inside the Modal */
  children: _propTypes.element.isRequired,

  /** Function called when the user clicks the close icon for the Modal */
  closeModal: _propTypes.func.isRequired,

  /** Sets max-width of modal to large breakpoint if enabled */
  large: _propTypes.bool,

  /** Sets modal to fill the screen at mobile sizes */
  showFullscreenMobile: _propTypes.bool
};
var ModalWrapper = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "modal__ModalWrapper",
  componentId: "sc-hn5zbh-0"
})(["position:fixed;top:0;left:0;z-index:10;"]);
exports.ModalWrapper = ModalWrapper;
var ModalOverlay = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "modal__ModalOverlay",
  componentId: "sc-hn5zbh-1"
})(["position:absolute;top:0;left:0;background-color:", ";opacity:0.3;"], function (props) {
  return (0, _styles.colors)("black", props);
});
exports.ModalOverlay = ModalOverlay;
var ModalContentWrapper = (0, _styledComponents["default"])(function (_ref) {
  var theme = _ref.theme,
      showFullscreenMobile = _ref.showFullscreenMobile,
      large = _ref.large,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, rest);
}).withConfig({
  displayName: "modal__ModalContentWrapper",
  componentId: "sc-hn5zbh-2"
})(["background-color:", ";position:relative;max-width:", ";", ""], function (props) {
  return (0, _styles.colors)("white", props);
}, function (_ref2) {
  var theme = _ref2.theme,
      large = _ref2.large;
  return large ? theme.breakpointInts[1] + "px" : "577px";
}, function (_ref3) {
  var theme = _ref3.theme,
      showFullscreenMobile = _ref3.showFullscreenMobile;
  return showFullscreenMobile && theme && theme.breakpointInts ? (0, _styledComponents.css)(["@media (max-width:", "px){max-width:100%;}"], theme.breakpointInts[0]) : null;
});
exports.ModalContentWrapper = ModalContentWrapper;
var CloseIconWrapper = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "modal__CloseIconWrapper",
  componentId: "sc-hn5zbh-3"
})(["width:24px;height:24px;position:absolute;top:24px;right:24px;cursor:pointer;", ""], function (_ref4) {
  var theme = _ref4.theme;
  return theme && theme.breakpointInts ? (0, _styledComponents.css)(["@media (max-width:", "px){top:12px;right:12px;}"], theme.breakpointInts[0]) : null;
});
exports.CloseIconWrapper = CloseIconWrapper;
var CloseIcon = (0, _styledComponents["default"])(_elements.NavClose).withConfig({
  displayName: "modal__CloseIcon",
  componentId: "sc-hn5zbh-4"
})(["fill:", ";"], function (props) {
  return (0, _styles.colors)("gray-dark", props);
});
exports.CloseIcon = CloseIcon;

var Modal = function Modal(props) {
  var children = props.children,
      closeModal = props.closeModal,
      showFullscreenMobile = props.showFullscreenMobile,
      large = props.large;
  var close = (0, _utils.useEscapeClose)(closeModal);
  return /*#__PURE__*/_react["default"].createElement(ModalWrapper, {
    alignItems: "center",
    height: 1,
    justifyContent: "center",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(ModalOverlay, {
    height: 1,
    onClick: close,
    width: 1
  }), /*#__PURE__*/_react["default"].createElement(ModalContentWrapper, {
    alignItems: "flex-start",
    borderRadius: [showFullscreenMobile ? "0" : "10px", "10px"],
    flexDirection: "column",
    height: [showFullscreenMobile ? 1 : "auto", "auto"],
    justifyContent: "flex-start",
    large: large,
    p: [4, "72px"],
    showFullscreenMobile: showFullscreenMobile,
    width: [showFullscreenMobile ? 1 : "auto", "auto"]
  }, /*#__PURE__*/_react["default"].createElement(CloseIconWrapper, {
    onClick: close
  }, /*#__PURE__*/_react["default"].createElement(CloseIcon, null)), children));
};

Modal.propTypes = propTypes;
Modal.displayName = "Modules.Modal";
var _default = Modal;
exports["default"] = _default;